module.exports = __webpack_public_path__ + "static/media/battery.4ac4592f.svg";